<template>
    <div 
      class="modal fade" 
      id="modalAddPart" 
      role="dialog"
      data-backdrop="static" 
      data-keyboard="false" 
      aria-labelledby="modalLabel" 
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title black-text" style="font-weight: bold">
               Tambah Part
              </h4> 
            </div>
            <button type="button" class="close" data-dismiss="modal" @click="resetState">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
          </div>
          <div class="modal-body">
            <!-- Info Unit Section -->
            <div class="col-lg-12 mb-2">
                <div class="info-header">Info Unit</div>
                <div class="laptop-info-container">
                    <div class="info-unit-section">
                        <div class="info-content">
                            <div class="info-item laptop-title">
                                {{unitInfo.itemGroup}} - {{unitInfo.itemName}}
                            </div>
                            <div class="info-item laptop-title">
                                {{unitInfo.stockCode}} / {{unitInfo.id}}
                            </div>
                            <div v-for="(item,i) in unitInfo.bomItem" :key="`${item.itemGroup}-${i}`">
                                <div class="info-item laptop-title">
                                    {{item.itemName}}
                                </div>   
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Input Part Section -->
                <div class="col-lg-12">
                    <!-- Input part baru -->
                    <div class="mb-3">
                        <AutocompleteInput
                          v-model="searchNewPart"
                          :selectedPart ="selectedNewParts"
                          :warehouse="warehouse"
                          label="Part ditambah"
                          placeholder="Pilih part dari Ready Stock"
                        />
                        <div class="mt-3" v-for="(part,i) in selectedNewParts" :key="`${part}-${i}`">
                          <div class="d-flex align-items-center mb-2">
                            <div class="flex-grow-1  rounded px-3 py-2 mr-2" style="background: #CDCDCD;">
                              {{ part.itemName }}
                            </div>
                            <button class="btn btn-danger rounded-end" @click="removePart(part.code)">
                              <img src="~@/assets/icon/trash-white.png" width="18px" style="padding-bottom : 5px" />
                            </button>
                          </div>
                        </div>
                    </div>
                </div>
          </div>
          <!-- Footer -->
            <div class="modal-footer">
                <button type="button" class="btn close-button" data-dismiss="modal" @click="resetState">
                    Batal
                </button>
                <button class="btn confirm-button" @click="confirmAction" :disabled="selectedNewParts.length == 0">
                    Konfirmasi
                </button>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import AutocompleteInput from './AutocompleteInput.vue'
export default {
  name: 'ModalAddPart',
  components : {
    AutocompleteInput,
  },
  props: ['unitInfo','warehouse','submitChanges','currentSelectedPart'],
  data () {
    return {
      searchNewPart:'',
      selectedNewParts : [],
    }
  },
  methods:{
    resetState() {
      this.selectedNewParts = [...this.currentSelectedPart]
    },
    confirmAction() {
       this.submitChanges(this.selectedNewParts)
    },
    removePart(code) {
      this.selectedNewParts = this.selectedNewParts.filter(item => item.code !== code)
    },

    handleLogout() {
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
  },
  created(){
    this.admin = localStorage.getItem('admin_name')
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkbox-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.6rem;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid  #CFD3D9;
  background-color: #F8F9FA;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  padding: 0.5rem 0;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-custom {
  width: 1rem;
  height: 1rem;
  border: 2px solid #d1d5db;
  border-radius: 0.25rem;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkbox-input:checked + .checkbox-custom {
  background-color: #247FEC;
  border-color: #3b82f6;
}

.checkbox-input:checked + .checkbox-custom::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 3px;
  height: 7px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-label {
  font-size: 0.875rem;
  color: #374151;
  line-height: 1.25;
}

.close-button {
  background: none;
  border: 1px solid #2E3646;
  background-color: #F4F4F4;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  color: #6b7280;
  border-radius:  0.5rem;
  transition: all 0.2s ease;
}

.close-button:hover {
  color: #374151;
  background-color: #F4F4F4;
}

.confirm-button {
  background: none;
  border: 1px solid #247FEC;
  background-color: #3386eb;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  color: #FFFFFF;
  border-radius:  0.5rem;
  transition: all 0.2s ease;
}

</style>



// WEBPACK FOOTER //
// src/components/Assembly/CustomComponent/ModalAddPart.vue